<template>
    <tr>
        <td>{{ index + 1 }}</td>
        <td>
            <div class="d-flex justify-content-between">
                <p class="font-weight-bold">{{ group.name[locale] }}</p>
                <app-button native-type="button"
                            type="success"
                            data-toggle="collapse"
                            :data-target="`#group_${group.id}`"
                            aria-expanded="false"
                            :aria-controls="`group_${group.id}`"
                            small>
                    {{ $t('Vehicles') }}
                </app-button>
            </div>
            <app-draggable v-model="reorderedVehicles" v-bind="{ animation: 200 }" tag="div">
                <div v-for="(vehicle, i) in reorderedVehicles" :key="i" class="collapse" :id="`group_${group.id}`">
                    <div class="card pointer mb-1">
                        <div class="card-body d-flex justify-content-between align-items-center">
                            <div>
                                {{ vehicle.make.name }} {{ vehicle.model.name }} <app-vehicle-no :slug="vehicle.slug"/> <small>Reg: {{ vehicle.reg_no }}</small>
                            </div>
                            <app-button native-type="button" type="danger" @click="removeFromGroup(vehicle.id)" xsmall>
                                {{ $t('Remove') }}
                            </app-button>
                        </div>
                    </div>
                </div>
            </app-draggable>
        </td>
        <td class="p-0">
            <div class="text-right">
                <app-button v-if="$store.getters.canEditSettings" native-type="button" @click="$modal.show('update_group', {group})" small>
                    {{ $t('Edit') }}
                </app-button>
                <app-button v-if="$store.getters.canDeleteSettings" native-type="button" type="danger" @click="destroy" small>
                    {{ $t('Delete') }}
                </app-button>
            </div>
        </td>
    </tr>
</template>

<script>
import VehicleGroupService from '@services/vehicleGroup.service';
import CreateModal from './modals/Create';
import UpdateModal from './modals/Update';
import {mapGetters} from 'vuex';
import appDraggable from 'vuedraggable';
import Vue from 'vue';

export default {
    props: {
        group: Object,
        vehicles: Array,
        index: Number
    },
    computed: {
        ...mapGetters(['locale']),
        reorderedVehicles: {
            get() {
                return this.vehicles;
            },
            set(vehicles) {
                VehicleGroupService.reorderVehicles(vehicles).then(res => {
                    this.$toastr.s(this.$t(res.message));
                    this.$emit('reorderVehicles', {vehicles, group_id: this.group.id});
                });
            }
        },
    },
    methods: {
        destroy() {
            this.$emit('destroy', this.group.id);
        },
        removeFromGroup(vehicleId) {
            this.$emit('removeFromGroup', {group_id: this.group.id, vehicle_id: vehicleId});
        }
    },
    components: {
        appDraggable
    },
};
</script>
